import { AbstractCommand } from 'src/models/command';

class DelayTheTaskToSpecificDateCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_DelayTheTaskToSpecificDate';

	public constructor(aggregateId: string, targetDate: string) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
			targetDate: targetDate,
		};
	}
}

export { DelayTheTaskToSpecificDateCommand };
